import { render, staticRenderFns } from "./PostsEdit.vue?vue&type=template&id=3827dc11&scoped=true"
import script from "./PostsEdit.vue?vue&type=script&lang=js"
export * from "./PostsEdit.vue?vue&type=script&lang=js"
import style0 from "./PostsEdit.vue?vue&type=style&index=0&id=3827dc11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3827dc11",
  null
  
)

export default component.exports